import script from "./SparePartsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./SparePartsTable.vue?vue&type=script&setup=true&lang=ts"

import "./SparePartsTable.vue?vue&type=style&index=0&id=06192b31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06192b31"]])

export default __exports__